import { CustomComponentLabel, CustomComponentType } from '../../../../../enums';
import { PersonalFinancialTypeSelect } from '../personal-financial-type-select/personal-financial-type-select';
import { getKey } from '../../../../../components/form-components/simple-inputs/extended-field-helper';
import { createSubaccountDefaultEditConfiguration } from '../configuration';

export class PersonalInvestmentTypeSelect extends PersonalFinancialTypeSelect {
	static schema(...extend: any) {
		return PersonalFinancialTypeSelect.schema(
			{
				label: CustomComponentLabel()[CustomComponentType.personalInvestmentTypeSelect],
				type: CustomComponentType.personalInvestmentTypeSelect,
				key: CustomComponentType.personalInvestmentTypeSelect
			},
			...extend
		);
	}

	static editForm = createSubaccountDefaultEditConfiguration(CustomComponentType.personalInvestmentTypeSelectOptions);

	static get builderInfo() {
		return {
			title: CustomComponentLabel()[CustomComponentType.personalInvestmentTypeSelect],
			weight: 10,
			schema: PersonalInvestmentTypeSelect.schema()
		};
	}

	// @ts-ignore
	get key(): string {
		return getKey(this, super.key);
	}
}
